<template>
  <div>
    <header>
      <div class="back-link">
        <a :href="routeIndex">&#8592; Back to motion</a>
      </div>
    </header>
    <h1 class="align-center">
      {{ (isExists ? 'Edit ' + motion.title : 'Add video') + ' (' + (isShowreel ? 'Showreel' : 'Individual Project') + ')' }}
    </h1>

    <MotionForm :route-save="routeSave"
                :route-after-saving="routeIndex"
                :route-upload-video="routeUploadVideo"
                :subjects="preparedSubjects"
                :filters="preparedFilters"
                :motion="preparedMotion"
    />
  </div>
</template>

<script>
import MotionForm from './../../MotionForm.vue';
import helpers from './../../../mixins/helpers';

export default {
  mixins: [helpers],

  props: {
    routeIndex: {
      type: String
    },

    routeSave: {
      type: String
    },

    routeUploadVideo: {
      type: String
    },

    subjects: {
      type: Array
    },

    filters: {
      type: Array
    },

    motion: {
      type: Object
    },
  },

  components: {
    MotionForm
  },

  data() {
    return {
      isExists: !!this.motion,

      preparedMotion: {
        subjects: [],
        filters: []
      },

      preparedSubjects: [],

      preparedFilters: []
    };
  },

  created() {
    this.prepareData();
  },

  computed: {
    isShowreel() {
      return (this.isExists ? this.motion.type : this.getQueryParameterByName('type')) === 'showreel';
    }
  },

  methods: {
    prepareData() {
      if(this.isExists) {
        this.preparedMotion = this.motion;
      }

      this.preparedSubjects = this.subjects.map((subject) => {
        return {
          id: subject.id,
          title: subject.name,
          selected: this.preparedMotion.subjects.some(motionSubject => motionSubject.id === subject.id)
        };
      });

      this.preparedFilters = this.filters.map((filter) => {
        return {
          id: filter.id,
          title: filter.name,
          selected: this.preparedMotion.filters.some(motionFilter => motionFilter.id === filter.id)
        };
      });
    },
  },
};
</script>